import { render, staticRenderFns } from "./Dhcpsnooping.vue?vue&type=template&id=5d181f03&"
import script from "./Dhcpsnooping.vue?vue&type=script&lang=js&"
export * from "./Dhcpsnooping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports